module.exports = __webpack_public_path__ + "img/e_3_7_r.ebcb2a42.png";